import styled from 'styled-components';
import { Alert as ReactAlert } from 'react-bootstrap';

export const DashboardContainer = styled.div`
  background-color: ${(props) => props.theme.color.bg.muted};
  width: 100%;
  margin: auto;
  /* max-width: 1280px; */
  padding-top: 84px;
  min-height: calc(100vh - 60px);
  /* @media (max-width: 1280px) {
    padding: 0 40px;
  } */
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1416px;
  margin-left: auto;
  margin-right: auto;
  display: grid;
  grid-template-areas:
    'consumerunitlistcontainer consumerunitlistcontainer consumerunitlistcontainer'
    'consumerunitcontrols consumerunitcontrols consumerunitcontrols'
    'consumerunitselecteds consumerunitselecteds consumerunitselecteds'
    'consumerunitsdigest meanconsumption environmentresults'
    'consumptionforecast consumptionforecast consumptionforecast'
    'economyoportunities economyoportunities economyoportunities';
  gap: 16px;
  padding: 0 16px;

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0 12px;
  }
`;

export const ConsumerUnitFilterCount = styled.p`
  width: 100%;
  max-width: 1416px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 8px;
  padding: 0 16px;
  font-family: Montserrat;
  font-size: 14px;
  line-height: normal;
  color: ${(props) => props.theme.color.text.quaternary};

  img {
    margin-right: 8px;
  }

  @media only screen and (max-width: 768px) {
    padding: 0 12px;
  }
`;

export const ConsumerUnitListContainer = styled.div`
  grid-area: consumerunitlistcontainer;
  width: 100%;
  max-width: 1416px;
  overflow-x: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
`;

export const EconomyOpportunitiesContainer = styled.div`
  grid-area: economyoportunities;
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ConsumerUnitControls = styled.div`
  grid-area: consumerunitcontrols;
  position: relative;

  /* @media only screen and (max-width: ) {

  } */
`;

export const ConsumerUnitControl = styled.div`
  /* Por cima da borda do carrossel (nov/2026): ficavam a 72px para fora, o que
     criava rolagem horizontal na página e escondia a seta esquerda sob o menu
     lateral. */
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 64px;
  cursor: pointer;
  top: -207px;
  background-color: ${(props) => props.theme.color.bg.primary};
  border: 1px solid ${(props) => props.theme.color.ui.shade2};
  border-radius: 3px;
  &:hover {
    svg {
      path {
        fill: ${(props) => props.theme.color.text.primary};
      }
    }
  }
  &#previous {
    left: 4px;
  }
  &#next {
    right: 4px;
  }
`;

export const ConsumerUnitList = styled.div`
  grid-auto-flow: column;
  grid-gap: 16px;
  justify-content: flex-start;
`;

export const NoConsumerUnits = styled.div`
  width: 100%;
  max-width: 1416px;
  margin: 24px auto;
  display: flex;
  gap: 24px;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding: 10px;
  }
`;

export const EmptyAddCard = styled.div`
  background-color: ${(props) => props.theme.color.bg.primary};
  border: 1px solid transparent;
  border-radius: 3px;
  width: 260px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  cursor: pointer;
  gap: 12px;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${(props) => props.theme.color.ui.primary};
  }

  h4 {
    color: ${(props) => props.theme.color.ui.green};
    font-family: ${(props) => props.theme.font.title.family};
    font-weight: ${(props) => props.theme.font.title.weight.bold};
    margin: 0;
    align-self: flex-start;
  }

  p {
    color: ${(props) => props.theme.color.text.primary};
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    line-height: ${(props) => props.theme.font.body.lineHeight.regular};
    margin: 0;
    align-self: flex-start;

    strong {
      color: ${(props) => props.theme.color.text.secondary};
    }
  }
`;

export const EmptyAddIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.color.ui.green};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;

  svg {
    color: ${(props) => props.theme.color.ui.green};
    font-size: 28px;
  }
`;

export const EmptyPromoCard = styled.div`
  background-color: ${(props) => props.theme.color.bg.primary};
  border-radius: 3px;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 32px 40px;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding: 24px;
  }
`;

export const EmptyPromoText = styled.div`
  flex: 1;

  p {
    color: ${(props) => props.theme.color.text.quaternary};
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.regular};
    margin-bottom: 4px;
  }

  h2 {
    color: ${(props) => props.theme.color.ui.orange};
    font-family: ${(props) => props.theme.font.title.family};
    font-weight: ${(props) => props.theme.font.title.weight.bold};
    font-size: 28px;
    margin-bottom: 12px;
    line-height: 1.2;
  }

  span {
    display: block;
    color: ${(props) => props.theme.color.text.primary};
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    margin-bottom: 24px;
    line-height: ${(props) => props.theme.font.body.lineHeight.regular};
  }
`;

export const EmptyPromoButton = styled.button`
  background-color: ${(props) => props.theme.color.ui.primary};
  color: ${(props) => props.theme.color.text.inverse};
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-weight: ${(props) => props.theme.font.body.weight.bold};
  border: none;
  border-radius: 3px;
  padding: 10px 24px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const ConsumerUnitSelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  grid-area: consumerunitselecteds;
  gap: 30px;
  p {
    font-size: ${(props) => props.theme.font.body.size.small};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
    color: ${(props) => props.theme.color.text.primary};
    b {
      font-weight: ${(props) => props.theme.font.body.weight.bold};
    }
  }

  span {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
    color: ${(props) => props.theme.color.text.tertiary};
    cursor: pointer;
    text-decoration: underline;
  }
  margin-top: -10px;
  margin-bottom: -25px;
`;

export const NoConsumerUnitsContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 296px;
  width: 100%;
  max-width: 1416px;
  margin: auto;
  background-color: ${(props) => props.theme.color.bg.primary};
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    padding: 10px;
  }

  h2 {
    text-align: center;
    font-weight: ${(props) => props.theme.font.title.weight.semi};
    color: ${(props) => props.theme.color.text.tertiary};
    b {
      font-weight: ${(props) => props.theme.font.title.weight.bold};
    }
  }
  h4 {
    text-align: center;
    margin-bottom: 20px;
  }
`;

// Lembrete (laranja), não erro (out/2026 — era vermelho em toda visita).
export const Alert = styled(ReactAlert)`
  background-color: ${(props) => props.theme.color.bg.warning};
  color: ${(props) => props.theme.color.text.primary};
  border-left: 4px solid ${(props) => props.theme.color.ui.orange} !important;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  line-height: ${(props) => props.theme.font.body.lineHeight.regular};
  border: 0;
  border-radius: 0;
  margin: 0;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const DigestCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  column-gap: 20px;
  row-gap: 20px;
  width: 100%;
  max-width: 1416px;
  margin: auto;
  margin-bottom: 30px;

  @media only screen and (max-width: 1300px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    display: none;
  }
`;

export const SmallCard = styled.div<{ color?: string }>`
  display: flex;
  gap: 10px;
  align-items: center;
  background-color: #fff;
  height: 80px;
  min-width: 310px;
  /* width: 100%; */
  border-radius: 3px;
  padding: 10px;

  .card-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.color || props.theme.color.ui.orange};
    width: 48px;
    height: 48px;
    border-radius: 3px;

    svg {
      color: ${(props) => props.theme.color.ui.shade0};
      font-size: 16px;
    }
  }

  .card-description-container {
    h4,
    h2 {
      margin: 0;
      color: #333;
    }
    h4 {
      font-family: ${(props) => props.theme.font.title.family};
      font-weight: 500;
    }
    h2 {
      font-family: ${(props) => props.theme.font.body.family};
      font-weight: 700;
    }
  }
`;

export const MobileContainer = styled.div`
  margin-top: 60px;
  min-height: calc(100vh - 60px);
`;

export const MobileNoConsumerUnitConainer = styled.div`
  padding: 20px;

  display: flex;
  flex-direction: column;
`;

export const MobileCardContainer = styled.div`
  display: none;

  @media only screen and (max-width: 768px) {
    display: grid;
    padding: 20px 10px;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 10px;
  }
`;

export const MobileCardDigest = styled.div<{ color?: string }>`
  background-color: ${(props) => props.theme.color.bg.primary};
  /* background-color: ${(props) =>
    props.color ? props.color : props.theme.color.ui.orange}; */
  /* opacity: 0.3; */
  /* position: relative; */
  padding: 10px;
  /* height: 120px; */
  border-radius: 3px;

  h2,
  h4 {
    margin: 0;
  }

  .icon-container {
    svg {
      color: ${(props) =>
        props.color ? props.color : props.theme.color.ui.orange};
      font-size: 16px;
    }
    /* width: 50px;
    height: 50px; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* right: 10px; */
    /* top: calc(50% - 25px); */
    /* position: absolute; */
    /* background-color: ${(props) =>
      props.color ? props.color : props.theme.color.ui.orange}; */
    border-radius: 3px;
    /* opacity: 0.6; */
  }
`;
